<mat-icon
  *ngIf="task?.issueWasUpdated"
  color="accent"
  style="margin-right: 8px"
  >update
</mat-icon>
<mat-icon
  *ngIf="!task?.issueWasUpdated"
  style="margin-right: 8px"
  svgIcon="redmine"
>
</mat-icon>
<span class="tab-label-text">Redmine</span>
